module.exports = __webpack_public_path__ + "images/timeline.aa03c008.jpg";